import {
  searchSchema,
  type ClientesSearch,
  type TIPOS_CLIENTES,
} from '../-schemas';

export const FILTRO_CLIENTES_PADRAO = searchSchema.parse({});

export type TipoClientes = (typeof TIPOS_CLIENTES)[number];

export type FiltroClientes = ClientesSearch;

const CAMPOS_DA_TELA = ['detalhe', 'software', 'pagina'] as const;

type FiltroApi = Omit<FiltroClientes, (typeof CAMPOS_DA_TELA)[number]>;

/**
 * O filtro da URL como a API recebe: sem os campos que só controlam a tela (o detalhe aberto e a
 * página dele) e sem texto vazio. Os nomes já são os da API.
 */
export function filtroParaApi(filtro: FiltroClientes): Partial<FiltroApi> {
  return Object.fromEntries(
    Object.entries(filtro).filter(
      ([chave, valor]) =>
        !(CAMPOS_DA_TELA as readonly string[]).includes(chave) && valor !== '',
    ),
  );
}
